module.exports = __webpack_public_path__ + "img/NAS.3600d6ce.svg";